export default function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}



//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/moment/src/lib/utils/has-own-prop.js
// module id = 6
// module chunks = 0